export default "__VITE_ASSET__dB7OlDpD__"